const helpAndResources = {
  id: 'helpAndResources',
  title: 'Help & Resources',
  type: 'group',
  children: [
    {
      id: 'quickOverviewGuide',
      title: 'Quick Overview Guide',
      type: 'item',
      url: '/quick-overview-guide.pdf',
      breadcrumbs: false,
      isNewTab: true,
    },
    {
      id: 'helpDocumentation',
      title: 'Help Documentation',
      type: 'item',
      url: '#',
      breadcrumbs: false,
    },
    {
      id: 'tickets',
      title: 'My Support Tickets',
      type: 'item',
      url: '/support-tickets',
      breadcrumbs: false,
    },
  ],
};

export default helpAndResources;
